import {
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  Loading,
  MaskedInput,
  IconButton,
  Button,
  TextField,
} from "../../../../../components";
import { useEffect, useRef, useState } from "react";
import {
  notification,
  AdzapService,
  MensagemPersonalizadaService,
  SessionService,
  OrdemServicoService,
} from "../../../../../services";
import {
  encrypt,
  formatDate,
  responseErros,
  voltar,
} from "../../../../../utils";
import { format } from "date-fns";

const adzapService = new AdzapService();
const mensagemPersonalizadaService = new MensagemPersonalizadaService();
const sessionService = new SessionService();
const ordemServicoService = new OrdemServicoService();

const EnvioWhatsappNfeDialog = ({
  open,
  setOpen,
  envioMensagemManual,
  setEnvioMensagemManual,
  data,
  initialCollapses,
}) => {
  const componentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState("");
  const [nomeCompletoCliente, setNomeCompletoCliente] = useState("");
  const [erroCelular, setErroCelular] = useState(false);
  const empresaUsuario = sessionService.getEmpresaAndUsuario();

  useEffect(() => {
    if (open && data?.cliente?.id) {
      setCelular(data?.cliente?.celular);
      setNomeCompletoCliente(data?.cliente?.nomeRazaoSocial);
    }
  }, [open]);

  const handleInputChange = (event) => {
    setErroCelular(false);
    setCelular(event.target.value);
  };

  function handleCloseDialog() {
    setLoading(false);
    setCelular("");
    setOpen(false);
    initialCollapses();
    voltar();
  }

  async function handleSubmit() {
    if (!celular || celular.replace(/\D/g, "").length < 11) {
      notification.erroGenericos("Informe um número de celular válido");
      setErroCelular(true);
      return;
    }
    setLoading(true);
    const result = await ordemServicoService.getOS(data?.id, data?.dto);
    setLoading(false);
    if (!result.isAxiosError) {
      await enviarPdf({
        file: result.data,
        docName: `OS_Nº${data?.numeroDocumento}`,
      });
    } else {
      responseErros(result);
    }
  }

  function formatObjetoParaMensagem() {
    const ordemServico = { ...data?.ordemServico };
    const keys = Object.keys(data?.ordemServico || {});
    for (const key of keys) {
      if (Array.isArray(ordemServico[key])) {
        delete ordemServico[key];
      }
    }
    return ordemServico;
  }

  function formatarAtivos() {
    return (
      data?.ordemServico?.ativos
        ?.filter((ativo) => ativo.ativado !== false)
        .map((ativo) => {
          const nomeDoAtivo = ativo.descricao || ativo.nome || "Ativo";
          let textoAtivo = `*${nomeDoAtivo}*`;

          if (ativo.camposPersonalizados?.length) {
            const campos = ativo.camposPersonalizados
              .filter((campo) => campo.value)
              .sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
              .map((campo) => `${campo.label}: ${String(campo.value)}`)
              .join("\n");
            textoAtivo += `\n${campos}`;
          }
          return textoAtivo.toUpperCase();
        })
        .join("\n\n") || "NENHUM ATIVO VINCULADO."
    );
  }

  async function enviarPdf(dadosArquivo) {
    try {
      let text = "Segue Ordem de Serviço solicitada!";
      const getPrimeiroNome = (nomeCompleto) => {
        return nomeCompleto?.split(" ")[0] || "";
      };
      const nomeCliente = data?.cliente?.nomeRazaoSocial || nomeCompletoCliente;
      const ordemServico = formatObjetoParaMensagem();
      const linkPesquisaSatisfacao = gerarLinkPesquisaSatisfacao();
      const stringAtivosFormatados = formatarAtivos();
      const status = data?.ordemServico?.statusPersonalizadoId
        ? data?.statusList?.find(
            (s) => s.id == data?.ordemServico?.statusPersonalizadoId,
          )?.status ?? data?.ordemServico?.status
        : data?.ordemServico?.status ?? "";

      const texto = await mensagemPersonalizadaService.getMensagem({
        ...ordemServico,
        contexto: `ordem-servico-${status.toLowerCase()}`,
        linkPesquisaSatisfacao,
        apelidoFantasia: data?.empresa?.nome,
        nomeCompletoCliente: nomeCliente,
        primeiroNomeCliente: getPrimeiroNome(nomeCliente),
        nomeUsuario: empresaUsuario.usuario?.nome,
        dataFechamento: format(
          formatDate.received(data?.ordemServico?.dataFechamento),
          "dd/MM/yyyy",
        ),
        dataPrevistaFechamento: format(
          formatDate.received(data?.ordemServico?.dataPrevistaFechamento),
          "dd/MM/yyyy",
        ),
        dataAbertura: format(
          formatDate.received(data?.ordemServico?.dataAbertura),
          "dd/MM/yyyy",
        ),
        status,
        ativos: stringAtivosFormatados,
      });

      if (!texto.isAxiosError) {
        text = texto.data;
      } else {
        return responseErros(texto);
      }

      const result = await adzapService.enviarMensagem({
        number: celular,
        type: "document",
        file: dadosArquivo.file,
        docName: dadosArquivo.docName,
        text,
      });

      if (!result.isAxiosError) {
        handleCloseDialog();
        notification.sucessoGenericos("Documento enviado com sucesso!");
      } else {
        handleCloseDialog();
        responseErros(result);
      }
    } catch (error) {
      notification.erroGenericos("Falha no envio do documento");
    } finally {
      setEnvioMensagemManual(false);
      setLoading(false);
    }
  }

  function gerarLinkPesquisaSatisfacao() {
    if (envioMensagemManual) {
      return "_Link já enviado anteriormente! Caso já tenha respondido, favor desconsiderar esta seção._";
    } else {
      const baseUrl = window.location.origin;
      const base = {
        empresaId: empresaUsuario.empresa?.id,
        ordemServicoId: data?.id,
        nomeFantasia: empresaUsuario.empresa?.fantasia,
        cnpjCpf: empresaUsuario.empresa?.cnpjCpf,
      };
      const basicData = encrypt(base);
      return `${baseUrl}/cadastros/pesquisa-satisfacao/${basicData}`;
    }
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          left: "-9999px",
          width: "100%",
          maxWidth: "800px",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <div
          ref={componentRef}
          style={{
            width: "100%",
            display: "inline-block",
            backgroundColor: "white",
          }}
        ></div>
      </div>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={() => handleCloseDialog()}
      >
        <CardHeader title="Envio Whatsapp" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nomeCompletoCliente"
                name="nomeCompletoCliente"
                label="Nome"
                variant="outlined"
                fullWidth
                value={nomeCompletoCliente}
                onChange={(e) => setNomeCompletoCliente(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MaskedInput
                id="celular"
                name="celular"
                label="Celular"
                mask="(99) 9 9999-9999"
                onChange={handleInputChange}
                margin="none"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-device-mobile"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
                error={erroCelular}
                value={celular || ""}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                Enviar Documento
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <Loading loading={loading} />
      </Dialog>
    </>
  );
};

export default EnvioWhatsappNfeDialog;
